import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { DocumentTypeService } from '@core/services/document-type.service';
import { DocumentTypeActions } from './document-type.actions';

@Injectable()
export class DocumentTypeEffects {
  private actions$ = inject(Actions);
  private documentTypeService = inject(DocumentTypeService);
  private translateService = inject(TranslateService);
  getdocumentTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentTypeActions.loadDocumentTypes),
      mergeMap((data) =>
        this.documentTypeService.getDocumentTypes(data).pipe(
          map((documentTypes) =>
            documentTypes.success
              ? DocumentTypeActions.loadDocumentTypesSuccess(documentTypes)
              : DocumentTypeActions.loadDocumentTypesFailure(documentTypes)
          ),
          catchError((error) =>
            of(
              DocumentTypeActions.loadDocumentTypesFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  addDocumentType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentTypeActions.addEditDocumentType),
      mergeMap((data) =>
        this.documentTypeService.addDocumentType(data).pipe(
          map((documentType) => {
            if (documentType.success)
              return data.id
                ? DocumentTypeActions.updateDocumentTypeSuccess(documentType)
                : DocumentTypeActions.addDocumentTypeSuccess(documentType);
            else
              return DocumentTypeActions.addDocumentTypeFailure(documentType);
          }),
          catchError((error) =>
            of(
              DocumentTypeActions.addDocumentTypeFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
